import { useState, type ReactNode } from "react";
import ChevronLeft from "react-feather/dist/icons/chevron-left";
import ChevronRight from "react-feather/dist/icons/chevron-right";

import style from "./style.module.scss";
import Cover from "./cover";
import Page from "./page";
import { Button } from "../../../ui";
import { range } from "../../../utils";
import type {
  CalendarOptions,
  PageOptions,
  ProductEditProps,
  ProductPreviewProps,
} from "../../types";

export function Product({
  productId,
  userId,
  options,
  setOptions,
}: ProductEditProps<CalendarOptions>) {
  return (
    <div className={style.product}>
      <div className={style.step}>
        <p className={style.firstLine}>Couverture de votre calendrier</p>
        <p className={style.secondLine}>
          Définisser le style, la couleur et la photo de couverture.
        </p>
        <Cover productId={productId} userId={userId} options={options} setOptions={setOptions} />
      </div>

      <div className={style.step}>
        <p className={style.firstLine}>Choisissez la photo de chaque mois du calendrier</p>
        <p className={style.secondLine}>
          Clicker sur les différentes pages pour ajouter une photo ou glissez/déposer vos photos.
        </p>
        <div className={style.container}>
          {range(12).map((pageIndex) => (
            <Page
              key={pageIndex}
              options={options}
              page={options.pages[pageIndex]}
              productId={productId}
              userId={userId}
              index={pageIndex}
              onChange={(page: PageOptions) => {
                setOptions({
                  pages: {
                    ...options.pages,
                    [pageIndex]: page,
                  },
                });
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export const ProductPreview = ({ options }: ProductPreviewProps<CalendarOptions>) => {
  const [pageIndex, setPageIndex] = useState(0);
  return (
    <div className={style.preview}>
      {pageIndex === 0 && <Cover options={options} setOptions={() => {}} isPreview />}
      {pageIndex !== 0 && (
        <Page
          options={options}
          page={options?.pages?.[pageIndex - 1] || {}}
          index={pageIndex - 1}
          onChange={() => {}}
          isPreview
        />
      )}

      <div className={style.previewButtons}>
        <Button isPrimary onClick={() => setPageIndex(pageIndex === 0 ? 12 : pageIndex - 1)}>
          <ChevronLeft />
        </Button>
        <Button isPrimary onClick={() => setPageIndex(pageIndex === 12 ? 0 : pageIndex + 1)}>
          <ChevronRight />
        </Button>
      </div>
    </div>
  );
};

export const ProductThumbnail = (genericOptions: CalendarOptions): ReactNode => (
  <Cover options={genericOptions} setOptions={() => {}} isPreview />
);
